import {
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  Row,
  Table,
} from "reactstrap"
import {
  MdDelete,
  MdModeEdit,
  MdOutlineViewAgenda,
  MdFileDownload,
  MdOutlineAssignmentInd,
  MdQuestionMark,
  MdOutlinePrint,
  MdOutlineModeComment,
  MdOutlineExitToApp,
  MdEdit,
} from "react-icons/md"
import { FaSort, FaSortAlphaDown, FaSortAlphaUp } from "react-icons/fa"
import Select from "react-select"
import { SlDocs } from "react-icons/sl"
import { IoChatbubbleEllipsesOutline } from "react-icons/io5"
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react"
import {
  DataFilter,
  DataFilterColoredOptions,
  FilterStaff,
  ItemsPerPage,
  SearchFilter,
} from "components/Common/filters"
import { useSelector, useDispatch } from "react-redux"
import PaginationComponent from "components/Common/pagination"
import Loader from "components/Common/loader"
import {
  allApplications,
  ApplicationDelete,
  AllApplicationFetch,
  ApplicationFetch,
  DiscripantApplication,
  SendApplicationComment,
  SendRecommendation,
  GetMiscellaneousDocs,
  DeleteMiscellaneousDoc,
  SelectingCurrentApplication,
} from "redux/slice/applications/applicationSlice"
import ApplicationAssignStaff from "./application-assign-staff"
import { DateFormater } from "utilities/dateformater"
import { allStaffs, StaffFetch } from "redux/slice/staff/staffSlice"
import { SelectFieldForId, TextareaField } from "components/Common/input-fields"
import ApplicationComments from "./application-comments"
import { SHUK_AUTH_PORTAL_TOKEN, SHUK_ROLE_VIWEWER } from "redux/enums"
import { getUserTokenID, parseJwt } from "utilities/parse-jwt"
import Notify from "components/Common/notify"
import {
  allChatsData,
  ChatMessagesFetch,
  OpenNewChat,
  SetCurrentStaff,
} from "redux/slice/chats/chatSlice"
import { Link, useNavigate } from "react-router-dom"
import SidebarContext from "context/sidebar.context"
import fileImage from "../../assets/images/fileimage.png"

import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"
import MiscDocs from "./miscellaneous-docs"
import { convertCamelCaseToText } from "utilities/convertText"
import { userData } from "redux/slice/user/userSlice"

export default function ApplicationsTable(props) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { userRole } = useSelector(userData) 
  const { applicationsData, loading, totalPages, miscellaneousDocs } =
    useSelector(allApplications)
  const { staffId } = useSelector(allChatsData)
  const { staffMembersData } = useSelector(allStaffs) || {}
  const {
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    applicationFilters,
    setApplicationFilters,
    applicationCountryFilter,
    setApplicationCountryFilter,
    searchStaff,
    setSearchStaff,
    savedCurrentPage,
    setSavedCurrentPage,
    shouldRefetch,
    setShouldRefetch,
  } = useContext(SidebarContext)
  // const [itemsPerPage, setItemsPerPage] = useState(10)
  // const [currentPage, setCurrentPage] = useState(1)
  const [selectedApplication, setSelectedApplication] = useState({})
  const [assignModalState, setAssignModalState] = useState(false)
  const [commentsModalState, setCommentsModalState] = useState(false)
  const [discrepantModalState, setDiscrepantModalState] = useState(false)
  const [miscDocsModalState, setMiscDocsModalState] = useState(false)
  const [recommendationState, setRecommendationState] = useState(false)
  const [discrepant, setDiscrepant] = useState({
    status: "No",
    comments: "",
  })
  const [selectedId, setSelectedId] = useState(false)
  const [searchTerm, setSearchTerm] = useState("")
  const [sortBy, setSortBy] = useState({
    label: "",
    order: false,
  })
  const [filters, setFilters] = useState({
    status: "",
  })

  const [openDropdown, setOpenDropdown] = useState(null)
  const toggle = id => {
    setOpenDropdown(prev => (prev === id ? null : id))
  }

  const [recommendationStatusUpdate, setRecommendationStatusUpdate] = useState({
    errorCode: 0,
  })
  const [recommendationValues, setrecommendationValues] = useState("")
  // console.log("render applications comp")
  // const filteredApplications = useMemo(() => {
  //   return applicationsData?.filter(app =>
  //       !searchStaff || app.staffAssigned.includes(searchStaff)
  //     )
  //     .filter(app =>
  //       !searchTerm || Object.values(app).some(value =>
  //         String(value).toLowerCase().includes(searchTerm.toLowerCase())
  //       )
  //     );
  // }, [applicationsData, searchTerm, searchStaff]);

  // const predefinedValues = {
  //   Accepted: `<p>Congratulations,&nbsp;${selectedApplication && selectedApplication?.firstName ? selectedApplication?.firstName: ""} ${selectedApplication && selectedApplication?.middleName ? selectedApplication?.middleName : ""} ${selectedApplication && selectedApplication?.lastName ? selectedApplication?.lastName : ""}</p><p><br></p><p>The Shukre Ilahi Board has approved your application for a scholarship. We are pleased to award you financial support towards your education. The award is for your tuition fees in the amount communicated to you in the application portal, until your graduation.</p><p><br></p><p>Please note that this scholarship, is subject to you maintaining your academic performance and attendance record. It is your responsibility to provide evidence of this by <strong>submitting a copy of your exam mark sheet</strong> at the end of each semester.&nbsp;</p><p><br></p><p>In order to assist us with a timely remittance of your tuition fees you are required to:</p><ul><li><strong>Submit your fee receipts each term</strong>&nbsp;before a payment can be made for a subsequent term. Failure to do this will result in a delay in your payment.</li><li>Inform Shukre Ilahi of your <strong>fee due</strong> <strong>date</strong> as soon as they are sent to you each semester, failure to send us fee due dates in a timely manner will result in you not getting your fees paid.</li></ul><p><br></p><p>Payments for subsequent years will depend on the availability of funds and, therefore subject to change.</p><p><br></p><p><strong>Link to Moeen Form:</strong>&nbsp;<a href="https://shukreilahi.org/Moeenform.pdf" rel="noopener noreferrer" target="_blank">https://shukreilahi.org/Moeenform.pdf</a>&nbsp;-&nbsp;&nbsp;For students in India only.</p><p><br></p><p><strong>Link to OTF form</strong>&nbsp;-<a href="https://docs.google.com/forms/d/e/1FAIpQLScdydwol0h01tSYtPlH_NNiKrssWnX-W-MWlsoeZhFQHN8D5w/viewform" rel="noopener noreferrer" target="_blank">https://docs.google.com/forms/d/e/1FAIpQLScdydwol0h01tSYtPlH_NNiKrssWnX-W-MWlsoeZhFQHN8D5w/viewform</a>&nbsp;- For students in Pakistan only.</p><p><br></p><p>We, at Shukre Ilahi, strongly feel that lack of funds should not be a barrier for a good and deserving student to achieve academic success. Therefore, we encourage you to help other students, such as yourself, by donating back to the Shukre Ilahi Scholarship Fund once you graduate and can do so. When you are ready to donate back, please contact us for details of your local Shukre Ilahi agents.</p><p><br></p><p>Our Best Wishes are always with you for continued success in your chosen career path.</p><p><br></p><p>Salaams,</p><p><br></p><p>The Shukre Ilahi Board.</p>`,
  //   Rejected: `<p>Dear ${selectedApplication && selectedApplication?.firstName ? selectedApplication?.firstName: ""} ${selectedApplication && selectedApplication?.middleName ? selectedApplication?.middleName : ""} ${selectedApplication && selectedApplication?.lastName ? selectedApplication?.lastName : ""}</p><p><br></p><p>We would like to thank you for your application for a Shukre Ilahi scholarship. We regret to inform you that after carefully reviewing your application and information provided, your scholarship application was not successful. We wish you the very best in your pursuit of higher education.</p><p><br></p><p>Sincerely,</p><p><br></p><p>The Shukre Ilahi Committee</p>`,
  //   Hold: `<p>Dear ${selectedApplication && selectedApplication?.firstName ? selectedApplication?.firstName: ""} ${selectedApplication && selectedApplication?.middleName ? selectedApplication?.middleName : ""} ${selectedApplication && selectedApplication?.lastName ? selectedApplication?.lastName : ""}</p>`,
  // }

  // useEffect(() => {
  //   console.log(
  //     recommendationStatusUpdate?.type,
  //     predefinedValues[recommendationStatusUpdate.type],
  //   )

  //   if (
  //     recommendationStatusUpdate?.type &&
  //     predefinedValues[recommendationStatusUpdate.type]
  //   ) {
  //     setrecommendationValues(predefinedValues[recommendationStatusUpdate.type])
  //   }
  // }, [recommendationStatusUpdate?.type])

  const isViewer = userRole === SHUK_ROLE_VIWEWER

  const handlerecommendationValuesChange = value => {
    // console.log("handlerecommendationValuesChange", value)
    setrecommendationValues(value)
  }

  const handleSorting = _sortby => {
    if (sortBy.label === _sortby) {
      setSortBy(prev => ({
        ...prev,
        order: !sortBy.order,
      }))
    } else {
      setSortBy(prev => ({
        ...prev,
        label: _sortby,
        order: true,
      }))
    }
  }

  const paginate = pageNumber => {
    console.log("paginate call with page number: ", pageNumber)
    setCurrentPage(pageNumber)
    // setSavedCurrentPage(pageNumber)
    let data = {
      Search: searchTerm,
      pageNumber: pageNumber,
      pageSize: itemsPerPage,
      StaffId: searchStaff,
      Country: applicationCountryFilter,
      ApplicationStatus: applicationFilters.status
        ? applicationFilters.status
        : null,
      asce: sortBy.order,
      SortBy: sortBy.label ? sortBy.label : null,
    }
    dispatch(AllApplicationFetch(data))
  }

  const findingCurrentUser = async () => {
    let currentUserId = await getUserTokenID()
    dispatch(SetCurrentStaff(currentUserId))
  }

  // useEffect(() => {
  //   console.log("applicationFilter $", applicationFilters)
  // }, [applicationFilters])

  useEffect(() => {
    findingCurrentUser()
    dispatch(StaffFetch({IsDelete: false}))
  }, [])

  useEffect(() => {
    // console.log("applicationFilters.status", applicationFilters)
    if (shouldRefetch) {
      let data = {
        Search: searchTerm,
        pageNumber: currentPage,
        pageSize: itemsPerPage,
        StaffId: searchStaff,
        Country: applicationCountryFilter,
        ApplicationStatus: applicationFilters.status
          ? applicationFilters.status
          : null,
        asce: sortBy.order,
        SortBy: sortBy.label ? sortBy.label : null,
      }
      console.log("Applications Fetch Filter::", data)
      // let page = savedCurrentPage > 1 ? savedCurrentPage : 1
      // setCurrentPage(1)
      dispatch(AllApplicationFetch(data))
    }
    // Depend on primitive values (not the object references) so that the
    // SidebarContext recreating `applicationFilters`/`sortBy` objects with the
    // same values does not cause duplicate fetches on mount/navigation.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    itemsPerPage,
    applicationFilters?.status,
    searchStaff,
    applicationCountryFilter,
    sortBy?.label,
    sortBy?.order,
    shouldRefetch,
  ])

  const handleItemsPerPage = perPage => {
    console.log("perPage", perPage)
    if (perPage !== itemsPerPage) {
      setCurrentPage(1)
    }
    setItemsPerPage(Number(perPage))
  }

  const handleView = received => {
    // console.log("view", received)
    // dispatch(SelectingCurrentApplication(received))
    // props.forUpdate(received)
    // navigate(`/applications/${received?.id}`)
    // dispatch(ApplicationFetch(received?.id))
    // dispatch(GetMiscellaneousDocs(received?.id))
  }

  const handleDownload = received => {
    console.log("downloading...")
    props.handleDownload(received?.id)
  }

  const handleAssignModal = () => {
    // console.log("receive_ids table", receive_ids)
    setAssignModalState(!assignModalState)
  }

  const handleQueries = received => {
    console.log("queries", received)
  }

  const handleChatStart = async received => {
    // console.log("starting chat with", received)
    let newUserdata = {
      studentId: received?.id,
      studentName:
        received?.firstName +
        " " +
        received?.middleName +
        " " +
        received?.lastName,
      isRead: true,
    }
    dispatch(OpenNewChat(newUserdata))
    const token = localStorage.getItem(SHUK_AUTH_PORTAL_TOKEN)
    // if(token){
    let parsedToken = await parseJwt(token)
    let _staffId =
      parsedToken?.[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
      ]
    let datatoFetchMsgs = {
      studentId: received?.id,
      staffId: _staffId || "",
    }
    dispatch(ChatMessagesFetch(datatoFetchMsgs))
    // }
    navigate("/chat")
  }

  const handlePrint = received => {
    console.log("printing...")
    props.handlePrint(received?.id)
  }

  const handleCommentsModal = received => {
    dispatch(SelectingCurrentApplication(received))
    setCommentsModalState(!commentsModalState)
  }

  const handleDiscrepant = async () => {
    // console.log("discrepant this", selectedId.id)
    // console.log("discrepant", discrepant)
    // const token = localStorage.getItem(SHUK_AUTH_PORTAL_TOKEN)
    // let parsedDetails = await parseJwt(token)
    // let userId = parsedDetails?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"]
    let userId = await getUserTokenID()
    if (selectedId?.id && userId) {
      console.log("user/staff Id for discrepant ->", userId)
      let data = {
        stdId: selectedId.id,
        discrepantStatus: discrepant.status === "Yes" ? true : false,
        comments: "",
      }
      dispatch(DiscripantApplication(data))
        .then(res => {
          console.log(res)
          if (res.payload?.status && discrepant?.comments) {
            let dateTime = new Date().toISOString()
            let commentsData = {
              // StaffId: "96fe0338-75b4-4551-b5ae-08dcf4dbc176",
              StaffId: userId,
              studentId: selectedId.id,
              commentData: {
                comments: discrepant?.comments,
                time: dateTime,
              },
            }
            // dispatch(SendApplicationComment(commentsData))
            // .then((resp)=>{
            //   console.log("response of sending comment in application", resp?.payload)
            //   if(resp?.payload?.status === 200){
            //     setDiscrepant((prev)=>({
            //       ...prev,
            //       comments: "",
            //     }))
            //   }
            // })
            // .catch((err)=>{
            //   console.log("Error sending comment", err)
            // })
            setDiscrepantModalState(false)
          } else {
            setDiscrepant(prev => ({
              ...prev,
              comments: "",
            }))
            setDiscrepantModalState(false)
          }
        })
        .catch(err => {
          console.log(err)
        })
    } else {
      Notify("error", "Staff not found")
    }
  }

  const handleRecommendation = () => {
    let data = {
      studentId: selectedApplication?.id,
      status: recommendationStatusUpdate?.type,
      sentEmail:
        recommendationStatusUpdate?.type === "Graduated" ||
        recommendationStatusUpdate?.type === "In Process" ||
        recommendationStatusUpdate?.type === "Hold" ||
        recommendationStatusUpdate?.type === "Returning"
          ? false
          : true,
      message:
        recommendationStatusUpdate?.type === "Graduated" ||
        recommendationStatusUpdate?.type === "In Process" ||
        recommendationStatusUpdate?.type === "Hold" ||
        recommendationStatusUpdate?.type === "Returning"
          ? ""
          : recommendationValues,
      rejectionCode:
        recommendationStatusUpdate?.type === "Rejected"
          ? Number(recommendationStatusUpdate?.errorCode)
          : null,
    }
    console.log("data for recom api", data)
    dispatch(SendRecommendation(data))
      .then(res => {
        console.log("recommendation response %", res)
        if (res?.payload?.status === 200) {
          setRecommendationState(false)
          setRecommendationStatusUpdate(prev => ({
            ...prev,
            errorCode: 0,
          }))
        }
      })
      .catch(err => {
        console.log(err)
      })
  }

  const handleMiscDocs = app => {
    // misc docs
    dispatch(SelectingCurrentApplication(app))
    dispatch(GetMiscellaneousDocs(app?.id))
    setMiscDocsModalState(true)
  }

  const handleCloseMiscDocs = () => {
    setMiscDocsModalState(false)
  }

  const handleDeleteMiscDoc = doc_id => {
    // misc docs
    let data = {
      studentId: selectedApplication?.id,
      documentId: doc_id,
    }
    console.log("data to delete misc", data)
    dispatch(DeleteMiscellaneousDoc(data))
  }

  function calculateAge(dateOfBirth) {
    var today = new Date()
    var birthDate = new Date(dateOfBirth)
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  const handleSelectRecommendationChange = (id, value, name) => {
    // Accepted, Hold, Rejected
    setRecommendationStatusUpdate(prev => ({
      ...prev,
      id,
      [id]: value,
      type: value,
    }))
    const predefinedValues = {
      // Accepted: `<p>Congratulations,&nbsp;${name}</p><p><br></p><p>The Shukre Ilahi Board has approved your application for a scholarship. We are pleased to award you financial support towards your education. The award is for your tuition fees in the amount communicated to you in the application portal, until your graduation.</p><p><br></p><p>Please note that this scholarship, is subject to you maintaining your academic performance and attendance record. It is your responsibility to provide evidence of this by <strong>submitting a copy of your exam mark sheet</strong> at the end of each semester.&nbsp;</p><p><br></p><p>In order to assist us with a timely remittance of your tuition fees you are required to:</p><ul><li><strong>Submit your fee receipts each term</strong>&nbsp;before a payment can be made for a subsequent term. Failure to do this will result in a delay in your payment.</li><li>Inform Shukre Ilahi of your <strong>fee due</strong> <strong>date</strong> as soon as they are sent to you each semester, failure to send us fee due dates in a timely manner will result in you not getting your fees paid.</li></ul><p><br></p><p>Payments for subsequent years will depend on the availability of funds and, therefore subject to change.</p><p><br></p><p><strong>Link to Moeen Form:</strong>&nbsp;<a href="https://shukreilahi.org/Moeenform.pdf" rel="noopener noreferrer" target="_blank">https://shukreilahi.org/Moeenform.pdf</a>&nbsp;-&nbsp;&nbsp;For students in India only.</p><p><br></p><p><strong>Link to OTF form</strong>&nbsp;-<a href="https://apply.shukreilahi.org" rel="noopener noreferrer" target="_blank">https://apply.shukreilahi.org</a>&nbsp;- For students in Pakistan only.</p><p><br></p><p>We, at Shukre Ilahi, strongly feel that lack of funds should not be a barrier for a good and deserving student to achieve academic success. Therefore, we encourage you to help other students, such as yourself, by donating back to the Shukre Ilahi Scholarship Fund once you graduate and can do so. When you are ready to donate back, please contact us for details of your local Shukre Ilahi agents.</p><p><br></p><p>Our Best Wishes are always with you for continued success in your chosen career path.</p><p><br></p><p>Salaams,</p><p><br></p><p>The Shukre Ilahi Board.</p>`,
      Accepted: `<p><span style="color: black;">Congratulations &nbsp;${name}</span>,</p><p><span style="color: black;">&nbsp;</span></p><p><span style="color: black;">The Shukre Ilahi Board has approved your application for a scholarship. We are pleased to award you financial support towards your education. The award is for your tuition fees in the amount communicated to you in the application portal, until your graduation.</span></p><p><br></p><p><span style="color: black;">Please note that this scholarship is subject to you maintaining your academic performance and attendance record. It is your responsibility to provide evidence of this.</span></p><p><br></p><p><span style="color: black;">All communication with you will be through your portal, you will have access to it for the entire time that we are giving you financial assistance. &nbsp;</span></p><p><br></p><p><span style="color: black;">To assist us with a timely remittance of your tuition fees you are required to log in to your portal and upload:</span></p><p><br></p><ul><li><span style="color: black;">your</span><strong style="color: black;">&nbsp;mark sheet each semester&nbsp;</strong><span style="color: black;">before a payment can be made for a subsequent term. Failure to do this will result in a delay in your payment.</span></li><li>inform Shukre Ilahi of your&nbsp;<strong>fee due</strong>&nbsp;<strong>date</strong>&nbsp;as soon as it is sent to you each semester, failure to send us fee due dates in a timely manner will result in you not getting your fees paid.</li></ul><p><br></p><p><span style="color: black;">Payments for subsequent years will depend on the availability of funds and, therefore, are subject to change.</span></p><p><br></p><p><span style="color: black;">Your fees will be sent directly to your institution from our local agents.</span></p><p><br></p><p><span style="color: blue;">&nbsp;</span><span style="color: rgb(192, 0, 0);">For students in India only.&nbsp;</span><span style="color: black;">Visit&nbsp;</span><a href="http://www.moeenmemorial.org/" rel="noopener noreferrer" target="_blank" style="color: rgb(17, 85, 204);">www.moeenmemorial.org</a><span style="color: black;">.&nbsp;Click on ‘Apply for a scholarship”, create a log in and fill out their form.</span></p><p><br></p><p><span style="color: rgb(192, 0, 0);">For students in Pakistan only. -&nbsp;</span><span style="color: black;">You are required to fill out the form below for OTF</span></p><p><a href="https://docs.google.com/forms/d/e/1FAIpQLScdydwol0h01tSYtPlH_NNiKrssWnX-W-MWlsoeZhFQHN8D5w/viewform" rel="noopener noreferrer" target="_blank" style="color: blue;">https://docs.google.com/forms/d/e/1FAIpQLScdydwol0h01tSYtPlH_NNiKrssWnX-W-MWlsoeZhFQHN8D5w/viewform</a></p><p><br></p><p><span style="color: black;">We, at Shukre Ilahi, strongly feel that lack of funds should not be a barrier for a good and deserving student to achieve academic success. Therefore, we encourage you to help other students, such as yourself, by donating back to the Shukre Ilahi Scholarship Fund once you graduate and can do so. When you are ready to donate back, please contact us for details of your local Shukre Ilahi agents.</span></p><p><br></p><p><span style="color: black;">Our Best Wishes are always with you for continued success in your chosen career path.</span></p><p><br></p><p><span style="color: black;">Salaams,</span></p><p><span style="color: black;">The Shukre Ilahi Board.</span></p>`,
      Rejected: `<p>Dear ${name}</p><p>&nbsp;</p><p>We would like to thank you for your application for a Shukre Ilahi scholarship.</p><p><br></p><p>We regret to inform you that after carefully reviewing your application and information provided, your scholarship application was not successful.</p><p><br></p><p>We wish you the very best in your pursuit of higher education.</p><p><br></p><p>Sincerely,</p><p>The Shukre Ilahi Committee</p>`,
      Hold: `<p>Dear ${name}</p><p><br></p>`,
      Process: ``,
      Returning: ``,
      Graduated: ``,
    }
    if (value === "Accepted") {
      setrecommendationValues(predefinedValues.Accepted)
    } else if (value === "Hold") {
      setrecommendationValues(predefinedValues.Hold)
    } else if (value === "Rejected") {
      setrecommendationValues(predefinedValues.Rejected)
    } else if (value === "In Process") {
      setrecommendationValues(predefinedValues.Process)
    } else if (value === "Returning") {
      setrecommendationValues(predefinedValues.Returning)
    } else if (value === "Graduated") {
      setrecommendationValues(predefinedValues.Graduated)
    }
  }

  const debounceTimeout = useRef(null)
  const handleSearchApplications = text => {
    setSearchTerm(text)
    console.log("application status search", applicationFilters?.status)
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current)
    }

    debounceTimeout.current = setTimeout(() => {
      let data = {
        Search: text,
        pageNumber: currentPage,
        pageSize: itemsPerPage,
        StaffId: text === "" ? searchStaff : null,
        Country: applicationCountryFilter,
        ApplicationStatus:
          text === ""
            ? applicationFilters?.status
              ? applicationFilters?.status
              : null
            : null,
        asce: sortBy.order,
        SortBy: sortBy.label ? sortBy.label : null,
      }
      console.log("data search", data)
      dispatch(AllApplicationFetch(data))
    }, 1200)
  }

  return (
    <div className="application-table-container">
      <Row>
        <Col lg={12}>
          <Card className="app-table-card">
            <CardTitle className="fs-2 ms-3 dot-after">Applications</CardTitle>
            <CardBody>
              {/* Legend Section with Color Boxes */}
              {/* <div className="mb-3">
                <h6>Legend:</h6>
                <div className="d-flex align-items-center mb-2">
                  <span
                    className="badge bg-warning me-2"
                    style={{ width: "20px", height: "20px", display: "inline-block" }}
                  ></span>
                  <span>Not Eligible</span>
                </div>
                <div className="d-flex align-items-center">
                  <span
                    className="badge bg-success me-2"
                    style={{ width: "20px", height: "20px", display: "inline-block" }}
                  ></span>
                  <span>Eligible (age between 18 and 30)</span>
                </div>
              </div> */}
              <div className="row">
                {/* i have remove align-items-center for both one below one */}
                <div className="row col-sm-12 col-md-4 me-auto w-sm-100 float-start d-flex flex-column flex-wrap mb-1">
                  {/* <div className="row"> */}
                  <div className="col-sm-12 col-md-6 d-flex align-items-center">
                    <span
                      className="badge me-1 text-bg-danger badge-custom"
                      style={{
                        width: "12px",
                        height: "12px",
                        // flexShrink: 0,
                        display: "inline-block",
                      }}
                    ></span>
                    <span className="me-2 text-nowrap">Income Ineligible</span>
                  </div>
                  <div className="col-sm-12 col-md-6 d-flex align-items-center me-2">
                    <span
                      className="badge me-1 text-bg-warning badge-custom"
                      style={{
                        width: "12px",
                        height: "12px",
                        // flexShrink: 0,
                        display: "inline-block",
                      }}
                    ></span>
                    <span className="me-2 text-nowrap">Age Ineligible</span>
                  </div>
                  {/* </div> */}
                </div>
                <div
                  className="float-end col-sm-12 col-md-8 d-flex justify-content-end flex-row align-items-center"
                  // style={{ width: "100%" }}
                >
                  {/* <div className="me-auto w-sm-100">
                    <div className="d-flex align-items-center mb-2">
                      <span
                        className="badge me-2 text-bg-warning"
                        style={{ width: "15px", height: "15px", display: "inline-block" }}
                      ></span>
                      <span className="me-3 text-nowrap">Age Not Eligible</span>
                    </div>
                  </div> */}
                  <div className="me-3">
                    <SearchFilter
                      value={searchTerm}
                      label="Search Application"
                      onChange={e => {
                        handleSearchApplications(e.target.value)
                      }}
                    />
                  </div>
                  <div className="me-3" style={{ maxWidth: "20%" }}>
                    <DataFilter
                      label="Staff"
                      options={
                        staffMembersData?.map(staffObj => ({
                          id: staffObj?.profileId,
                          name: `${staffObj?.firstName} ${staffObj?.middleName} ${staffObj?.lastName}`,
                        })) || []
                      }
                      value={searchStaff}
                      onChange={e => {
                        setSearchStaff(e.target.value)
                      }}
                    />
                  </div>
                  <div className="me-3" style={{ maxWidth: "20%" }}>
                    <DataFilter
                      label="Country"
                      options={
                        [
                          // {id: "", name: "All"},
                          {id: "PK", name: "Pakistan"},
                          {id: "IN", name: "India"},
                          {id: "BD", name: "Bangladesh"},
                          {id: "LK", name: "Sri Lanka"},
                        ]
                      }
                      value={applicationCountryFilter}
                      onChange={e => {
                        setApplicationCountryFilter(e.target.value)
                      }}
                    />
                  </div>

                  <div className="me-3">
                    <DataFilterColoredOptions
                      options={[
                        {
                          id: "",
                          name: "All Application",
                          bgClr: "#ebedef",
                        },
                        {
                          id: "All",
                          name: "Active Application",
                          bgClr: "#ebedef",
                        },
                        {
                          id: "New",
                          name: "New Applications",
                          bgClr: "#bde9fe",
                        },
                        // { id: "Pending", name: "Pending Application" },
                        {
                          id: "In Process",
                          name: "In Process Applications",
                          bgClr: "#aafae9",
                        },
                        {
                          id: "Accepted",
                          name: "Accepted Applications",
                          bgClr: "#49ecc0",
                        },
                        {
                          id: "Hold",
                          name: "Hold Applications",
                          bgClr: "#ffcfce",
                        },
                        {
                          id: "Returning",
                          name: "Returning Applications",
                          bgClr: "#f4f7db",
                        },
                        {
                          id: "Rejected",
                          name: "Rejected Applications",
                          bgClr: "#ff8f8e",
                        },
                        {
                          id: "Graduated",
                          name: "Graduated",
                          bgClr: "#45b39d",
                        },
                      ]}
                      value={applicationFilters.status}
                      label="Application Status"
                      onChange={e => {
                        setShouldRefetch(false)
                        setApplicationFilters(prev => ({
                          ...prev,
                          status: e.target.value,
                        }))
                      }}
                    />
                  </div>
                  <div>
                    <ItemsPerPage
                      value={itemsPerPage}
                      handleItemsPerPage={handleItemsPerPage}
                    />
                  </div>
                </div>
              </div>

              <div
                className="app-table-body"
                // style={{minHeight: "48vh", maxHeight: "100%", overflowX: "auto", overflowY: "auto", position: "relative" }}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <Table className="table mb-0 table-bordered h-100">
                    <thead>
                      <tr>
                        <th
                          className="table-header-sort"
                          onClick={() => handleSorting("applicationId")}
                        >
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">
                              Application ID
                            </span>
                            {sortBy.label === "applicationId" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "applicationId" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th
                          className="table-header-sort"
                          onClick={() => handleSorting("submittedDate")}
                        >
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">
                              Submit Date
                            </span>
                            {sortBy.label === "submittedDate" &&
                              sortBy.order && <FaSortAlphaDown color="red" />}
                            {sortBy.label === "submittedDate" &&
                              !sortBy.order && <FaSortAlphaUp color="red" />}
                          </div>
                        </th>
                        <th
                          className="table-header-sort"
                          onClick={() => handleSorting("firstName")}
                        >
                          <div className="header-content">
                            <span className="text-nowrap table-head-label">
                              Student Name
                            </span>
                            {sortBy.label === "firstName" && sortBy.order && (
                              <FaSortAlphaDown color="red" />
                            )}
                            {sortBy.label === "firstName" && !sortBy.order && (
                              <FaSortAlphaUp color="red" />
                            )}
                          </div>
                        </th>
                        <th style={{ width: "20%" }} className="text-nowrap">
                          College Name
                        </th>
                        <th className="text-nowrap">Status</th>
                        <th className="text-nowrap">Action</th>
                        <th className="text-nowrap">Assigned Staff</th>
                        <th className="text-nowrap">Student Email</th>
                        <th className="text-nowrap">Student Contact</th>
                        {/* <th className="text-nowrap">Editable</th>
                        <th className="text-nowrap">Review Comments</th>
                        <th className="text-nowrap">Recommendations</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {applicationsData.map((app, index) => {
                        // const age = calculateAge(date);
                        let rowClass = false
                        let incomeIssue = false
                        let age = null
                        if (app?.dateOfBirth) {
                          age = calculateAge(app.dateOfBirth)
                          if (age < 16) {
                            // console.log("age", age)
                            // rowClass = "table-warning";
                            rowClass = true
                          }
                        }
                        if (app?.annualIncome && app?.annualIncome > 500000) {
                          incomeIssue = true
                        }
                        return (
                          <tr
                            key={app?.id}
                            className={``}
                            style={{ cursor: "pointer" }}
                            onClick={() => navigate(`/applications/${app?.id}`)}
                          >
                            {/* <td className="text-nowrap">{staff.id}</td> ["96fe0338-75b4-4551-b5ae-08dcf4dbc176", "358e0852-18fc-40c7-b5af-08dcf4dbc176"] */}
                            <td className="text-nowrap d-flex align-items-center justify-content-between">
                              {app?.applicationId}{" "}
                              {rowClass && (
                                <span
                                  className="badge me-2 text-bg-warning float-end"
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    display: "inline-block",
                                  }}
                                ></span>
                              )}{" "}
                              {incomeIssue && (
                                <span
                                  className="badge me-2 text-bg-danger float-end"
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    display: "inline-block",
                                  }}
                                ></span>
                              )}
                            </td>
                            <td
                              className="text-nowrap text-truncate"
                              style={{ maxWidth: "50px" }}
                            >
                              {app?.submittedDate &&
                              !String(app.submittedDate).startsWith("0001-01-01")
                                ? DateFormater(app?.submittedDate)
                                : ""}
                            </td>
                            <td
                              className="text-nowraptext-truncate"
                              style={{ cursor: "pointer", maxWidth: "200px" }}
                            >
                              {app?.firstName + " "}
                              {app?.middleName ? app?.middleName + " " : ""}
                              {app?.lastName ? app?.lastName : ""}
                            </td>
                            <td
                              style={{ maxWidth: "80px" }}
                              className="text-nowrap text-truncate"
                            >
                              {app?.instituteName}
                            </td>
                            <td className="text-nowrap">
                              {convertCamelCaseToText(app?.applicationStatus)}{" "}
                              {app?.applicationStatus === "Rejected" &&
                                app?.rejectionCode &&
                                "(" +
                                  convertCamelCaseToText(app?.rejectionCode) +
                                  ")"}
                            </td>
                            <td
                              className="d-flex"
                              onClick={e => e.stopPropagation()}
                            >
                              <div className="hover-text">
                                <Link to={`/applications/${app?.id}`}>
                                  <MdOutlineViewAgenda
                                    style={{ cursor: "pointer" }}
                                    className="me-2 text-success"
                                    // onClick={() => handleView(app)}
                                    size={20}
                                  />
                                </Link>
                                <span className="tooltip-text">View</span>
                              </div>
                              {/* <div className="hover-text">
                                <MdFileDownload
                                  style={{ cursor: "pointer" }}
                                  className="me-2 text-info"
                                  onClick={() => handleDownload(app)}
                                  size={20}
                                />
                                <span className="tooltip-text">Download</span>
                              </div> */}
                              {
                                !isViewer && (
                                  <div className="hover-text">
                                    <MdOutlineAssignmentInd
                                      style={{ cursor: "pointer" }}
                                      className="me-2 text-warning"
                                      onClick={() => {
                                        setSelectedApplication(app)
                                        handleAssignModal()
                                      }}
                                      size={20}
                                    />
                                    <span className="tooltip-text">
                                      Assign Staff
                                    </span>
                                  </div>
                                )
                              }
                            </td>
                            <td
                              style={{ maxWidth: "150px" }}
                              className="text-nowrap text-truncate"
                              onClick={e => e.stopPropagation()}
                            >
                              {app?.staffAssigned &&
                              app?.staffAssigned.length > 0
                                ? app.staffAssigned.map((staffId, index) => {
                                    const staffMember = staffMembersData.find(
                                      member => member.id === staffId,
                                    )
                                    return (
                                      <span key={staffId}>
                                        {staffMember
                                          ? staffMember.firstName
                                          : "Unknown"}
                                        {index < app.staffAssigned.length - 1 &&
                                          ", "}
                                        {/* {', '} */}
                                      </span>
                                    )
                                  })
                                : null}
                            </td>
                            <td
                              style={{ maxWidth: "100px" }}
                              className="text-nowrap text-truncate"
                            >
                              {app?.email}
                            </td>
                            <td
                              style={{ maxWidth: "80px" }}
                              className="text-nowrap text-truncate"
                            >
                              {app?.phoneNumber}
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </Table>
                )}
              </div>
            </CardBody>
            <CardFooter>
              <div className="d-flex justify-content-center justify-content-md-end justify-content-lg-end align-items-center flex-wrap">
                <div style={{ marginLeft: "4px" }}>
                  <PaginationComponent
                    totalPages={totalPages}
                    currentPage={currentPage}
                    paginate={paginate}
                  />
                </div>
              </div>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Modal isOpen={assignModalState} centered>
        <ApplicationAssignStaff
          handleAssignModal={handleAssignModal}
          selectedApplication={selectedApplication}
        />
      </Modal>
      <Modal isOpen={commentsModalState} centered size="lg">
        {/* <ApplicationComments
          handleCommentsModal={handleCommentsModal}
          selectedApplication={selectedApplication}
        /> */}
        <ApplicationComments />
        <div className="m-1">
          <button
            className="btn btn-danger float-end"
            onClick={() => setCommentsModalState(false)}
          >
            Close
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={discrepantModalState}
        onClosed={() => setSelectedId("")}
        centered
      >
        <Card className="bg-white">
          <CardBody className="mt-2">
            <h5 className="mb-2" style={{ fontWeight: "normal" }}>
              Are You Sure. You want to make{" "}
              <span className="fw-bold">
                {selectedId.firstName + " " + selectedId?.lastName}
              </span>{" "}
              application editable?
            </h5>
            <SelectFieldForId
              className="col-sm-12 col-md-12 col-lg-12 my-2"
              label="Editable"
              compulsory={true}
              disabled={false}
              selectOptions={[
                { id: "No", name: "No" },
                { id: "Yes", name: "Yes" },
              ]}
              value={!discrepant.status ? "No" : discrepant?.status}
              placeholder="Type Currency"
              onChange={e =>
                setDiscrepant(prev => ({
                  ...prev,
                  status: e.target.value,
                }))
              }
            />
            {/* <div className={`col-sm-12 col-md-12 col-lg-12 my-2`}>
                <label>Comments</label>
                <textarea
                  className={`form-control text-black`}
                  rows={3}
                  disabled={true}
                  value={discrepant.comments}
                  placeholder="Enter Comments"
                  onChange={e => setDiscrepant((prev)=>({
                    ...prev,
                    comments: e.target.value,  
                  }))}
                  required
                />
              </div> */}
            {/* <TextareaField
                label="Comments"
                className="col-sm-12 col-md-12 col-lg-12 my-2"
                compulsory={true}
                disabled={false}
                rows="3"
                value={discrepant.comments}
                placeholder="Enter Comments"
                onChange={e => setDiscrepant((prev)=>({
                  ...prev,
                  comments: e.target.value,  
                }))}
              /> */}
          </CardBody>
          <CardFooter>
            <div className="mt-4 float-end">
              <button
                className="btn btn-danger me-2"
                onClick={() => handleDiscrepant()}
              >
                Ok
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  setDiscrepantModalState(false)
                  setDiscrepant(prev => ({
                    ...prev,
                    status: "",
                    comments: "",
                  }))
                }}
              >
                Close
              </button>
            </div>
          </CardFooter>
        </Card>
      </Modal>
      <Modal isOpen={miscDocsModalState} onClosed={() => {}} size="lg" centered>
        <MiscDocs close={handleCloseMiscDocs} />
        {/* <Card className="bg-white">
          <CardBody className="mt-2">
            {
              loading ?
              <Loader /> :
              <>
                <h5 className="mb-2 text-secondary-si" style={{ fontWeight: "normal" }}>
                  Miscellaneous Documents
                </h5>
                {miscellaneousDocs && miscellaneousDocs.length > 0 ? miscellaneousDocs?.map((item, index) => (
                  <div className="" key={index}>
                    <h6 className="mt-3 text-secondary-si">Year {item?.year} Documents</h6>
                    <div className="row">
                      {item?.documentUrls && item?.documentUrls?.length > 0
                        ? item?.documentUrls?.map((image, index) => (
                            <div
                              className="col-6 col-md-3 col-lg-2 d-flex justify-content-center mb-3"
                              key={index}
                              onClick={() => window.open(image?.documentUrl, "_blank")}
                            >
                              <div className="text-center position-relative" style={{cursor: "pointer"}}>
                                  <img
                                    src={fileImage}
                                    alt={`Year ${item?.year} Document`}
                                    className="img-thumbnail"
                                    style={{
                                      maxWidth: "100px",
                                      maxHeight: "100px",
                                      objectFit: "contain",
                                    }}
                                  />
                                  <p className="text-truncate text-wrap" style={{maxWidth: "100px", marginBottom: "30px"}}>{image?.documentType ? image?.documentType : "Other"}</p>
                                <button className="btn btn-danger btn-sm w-100 position-absolute start-0 bottom-0 mt-5" onClick={(e)=>{e.stopPropagation(); handleDeleteMiscDoc(image?.id)}}>
                                  <MdDelete />
                                </button>
                              </div>
                            </div>
                          ))
                        : null}
                    </div>
                  </div>
                )) : null}
              </>
            }
          </CardBody>
          <CardFooter>
            <div className="mt-4 float-end">
              <button
                className="btn btn-danger"
                onClick={() => {
                  setMiscDocsModalState(false)
                }}
              >
                Close
              </button>
            </div>
          </CardFooter>
        </Card> */}
      </Modal>

      <Modal
        isOpen={recommendationState}
        onClosed={() => setSelectedId("")}
        centered
        size="lg"
      >
        <Card className="bg-white">
          <CardBody className="mt-2">
            {recommendationStatusUpdate?.type === "Graduated" ||
            recommendationStatusUpdate?.type === "In Process" ||
            recommendationStatusUpdate?.type === "Hold" ||
            recommendationStatusUpdate?.type === "Returning" ? (
              <p className="fs-4 text-black">
                Are you sure to mark this application as "
                {recommendationStatusUpdate?.type}"?
              </p>
            ) : (
              <ReactQuill
                value={recommendationValues}
                onChange={e => handlerecommendationValuesChange(e)}
              />
            )}
            {recommendationStatusUpdate?.type === "Rejected" && (
              <SelectFieldForId
                className="col-sm-12 col-md-12 col-lg-12 mt-4"
                label="Rejection Code"
                compulsory={true}
                disabled={false}
                selectOptions={[
                  { id: 0, name: "No Response" },
                  { id: 1, name: "Income too High" },
                  { id: 2, name: "Studying Abroad" },
                  { id: 3, name: "Other" },
                ]}
                value={
                  recommendationStatusUpdate?.errorCode
                    ? recommendationStatusUpdate?.errorCode
                    : 0
                }
                placeholder="Type Currency"
                onChange={e =>
                  setRecommendationStatusUpdate(prev => ({
                    ...prev,
                    errorCode: e.target.value,
                  }))
                }
              />
            )}
          </CardBody>
          <CardFooter>
            <div className="mt-4 float-end">
              <button
                className="btn btn-danger me-2"
                disabled={loading}
                onClick={handleRecommendation}
              >
                Ok
              </button>
              <button
                className="btn btn-primary"
                disabled={loading}
                onClick={() => {
                  setRecommendationState(false)
                  setrecommendationValues("")
                  setRecommendationStatusUpdate(prev => ({
                    ...prev,
                    errorCode: 0,
                  }))
                }}
              >
                Close
              </button>
            </div>
          </CardFooter>
        </Card>
      </Modal>
    </div>
  )
}
